// import {
//   FaEnvelope,
//   FaPhoneAlt,
//   FaFacebookF,
//   FaTwitter,
//   FaLinkedinIn,
// } from "react-icons/fa";
// import React, { useState } from "react";
// import { Link } from "react-router-dom";

// export default function ClientNavbar() {
//   const [menuOpen, setMenuOpen] = useState(false);
//   const [activeDropdown, setActiveDropdown] = useState(null);
//   const [activeSubmenu, setActiveSubmenu] = useState(null);

//   const scrollToTop = () => {
//     window.scrollTo({ top: 0, behavior: "instant" });
//   };

//   const handleLinkClick = () => {
//     scrollToTop();
//     setMenuOpen(false);
//   };

//   const toggleDropdown = (menu) => {
//     setActiveDropdown(activeDropdown === menu ? null : menu);
//   };

//   const toggleSubmenu = (menu) => {
//     setActiveSubmenu(activeSubmenu === menu ? null : menu);
//   };

  
//   return (
//     <header className="main-header">
//       {/* ===== TOP BAR ===== */}
//       <div className="sdpm-topbar">
//         <div className="sdpm-topbar-container">
//           <div className="sdpm-topbar-left">
//             <p>
//               <FaEnvelope className="sdpm-icon" />
//               <a href="mailto:office@sdpmco.com" className="sdpm-link">
//                 office@sdpmco.com
//               </a>
//             </p>

//             <p>
//               <FaPhoneAlt className="sdpm-icon" />
//               <a href="tel:+917948971100" className="sdpm-link">
//                 +91 79489 71100
//               </a>
//             </p>
//           </div>

//           <div className="sdpm-topbar-right">
//             <a href="#"><FaFacebookF /></a>
//             <a href="#"><FaTwitter /></a>
//             <a href="#"><FaLinkedinIn /></a>
//           </div>
//         </div>
//       </div>

//       {/* ===== NAVBAR ===== */}
//       <div className="nav-container">
//         {/* Logo */}
//         <Link to="/" onClick={handleLinkClick} className="logo-section">
//           <img src="/assets/img/ca-logo.jpg" alt="Logo" className="logo" />
//           <div className="logo-text">
//             <h2>S D P M & Co.</h2>
//             <p>Chartered Accountants</p>
//           </div>
//         </Link>

//         {/* Hamburger */}
//         <div
//           className={`hamburger ${menuOpen ? "active" : ""}`}
//           onClick={() => setMenuOpen(!menuOpen)}
//         >
//           <span></span>
//           <span></span>
//           <span></span>
//         </div>

//         {/* Navigation */}
//         <nav className={`navbar ${menuOpen ? "open" : ""}`}>
//           <ul className="nav-links">
//             <li>
//               <Link to="/" onClick={handleLinkClick}>Home</Link>
//             </li>

//             {/* SERVICES */}
//             <li className={`dropdown ${activeDropdown === "services" ? "active" : ""}`}>
//               <button
//                 className="dropdown-btn"
//                 onClick={() => toggleDropdown("services")}
//               >
//                 Services ▾
//               </button>

//               <ul className="dropdown-menu">
//                 <li>
//                   <Link to="/audit-assurance" onClick={handleLinkClick}>
//                     Audit & Assurance
//                   </Link>
//                 </li>

//                 {/* TAXATION SUBMENU */}
//                 <li className="dropdown-sub">
//                   <button
//                     className="submenu-btn"
//                     onClick={() => toggleSubmenu("taxation")}
//                   >
//                     Taxation & Compliance ▸
//                   </button>

//                   <ul
//                     className={`dropdown-submenu ${
//                       activeSubmenu === "taxation" ? "show" : ""
//                     }`}
//                   >
//                     {/* NEWLY ADDED */}
//                     <li>
//                       <Link to="/taxation-compliance" onClick={handleLinkClick}>
//                         Taxation & Compliance
//                       </Link>
//                     </li>

//                     <li>
//                       <Link to="/direct-tax" onClick={handleLinkClick}>
//                         Direct Tax (Income Tax)
//                       </Link>
//                     </li>

//                     <li>
//                       <Link to="/indirect-tax" onClick={handleLinkClick}>
//                         Indirect Tax (GST)
//                       </Link>
//                     </li>
//                   </ul>
//                 </li>

//                 {/* CAPITAL MARKET SUBMENU */}
//                 <li className="dropdown-sub">
//                   <button
//                     className="submenu-btn"
//                     onClick={() => toggleSubmenu("capital")}
//                   >
//                     Capital Market & SEBI ▸
//                   </button>

//                   <ul
//                     className={`dropdown-submenu ${
//                       activeSubmenu === "capital" ? "show" : ""
//                     }`}
//                   >
//                       {/* NEWLY ADDED */}
//                     <li>
//                       <Link to="/capital-market-sebi" onClick={handleLinkClick}>
//                         Capital Market & SEBI Advisory
//                       </Link>
//                     </li>
//                     <li>
//                       <Link to="/depository-participant-audit" onClick={handleLinkClick}>
//                         DP Audit – NSDL/CDSL
//                       </Link>
//                     </li>

//                     <li>
//                       <Link to="/system-audit-capital-market" onClick={handleLinkClick}>
//                         System Audit
//                       </Link>
//                     </li>

//                     <li>
//                       <Link to="/exchange-sebi-compliances" onClick={handleLinkClick}>
//                         Exchange & SEBI
//                       </Link>
//                     </li>

//                     <li>
//                       <Link to="/ipo-listing-support" onClick={handleLinkClick}>
//                         IPO & Listing
//                       </Link>
//                     </li>

                  
//                   </ul>
//                 </li>

//                 <li>
//                   <Link to="/corporate-compliance" onClick={handleLinkClick}>
//                     Corporate & ROC
//                   </Link>
//                 </li>

//                 <li>
//                   <Link to="/business-advisory" onClick={handleLinkClick}>
//                     Business Advisory
//                   </Link>
//                 </li>

//                 <li>
//                   <Link to="/banking-finance" onClick={handleLinkClick}>
//                     Banking & Finance
//                   </Link>
//                 </li>

//                 <li>
//                   <Link to="/international-nri" onClick={handleLinkClick}>
//                     International & NRI
//                   </Link>
//                 </li>

//                 <li>
//                   <Link to="/outsourcing-other" onClick={handleLinkClick}>
//                     Outsourcing & Other
//                   </Link>
//                 </li>
//               </ul>
//             </li>

//             <li>
//               <Link to="/knowledgecenter" onClick={handleLinkClick}>
//                 Knowledge Center
//               </Link>
//             </li>

//             <li>
//               <Link to="/about" onClick={handleLinkClick}>About Us</Link>
//             </li>

//             <li>
//               <Link to="/career" onClick={handleLinkClick}>Career</Link>
//             </li>

//             <li>
//               <Link to="/contactus" onClick={handleLinkClick}>Contact Us</Link>
//             </li>

//           </ul>
//         </nav>
//       </div>
//     </header>
//   );
// }



import React, { useState } from "react";
import {
  FaEnvelope,
  FaPhoneAlt,
  FaFacebookF,
  FaTwitter,
  FaLinkedinIn,
} from "react-icons/fa";
import { Link } from "react-router-dom";

export default function ClientNavbar() {
  const [menuOpen, setMenuOpen] = useState(false);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "instant" });
  };

  const handleLinkClick = () => {
    scrollToTop();
    setMenuOpen(false);
  };

  return (
    <header className="main-header">
      {/* ===== TOP BAR ===== */}
      <div className="sdpm-topbar">
        <div className="sdpm-topbar-container">
          <div className="sdpm-topbar-left">
            <p>
              <FaEnvelope className="sdpm-icon" />
              <a href="mailto:office@sdpmco.com" className="sdpm-link">
                office@sdpmco.com
              </a>
            </p>

            <p>
              <FaPhoneAlt className="sdpm-icon" />
              <a href="tel:+917948971100" className="sdpm-link">
                +91 79489 71100
              </a>
            </p>
          </div>

          <div className="sdpm-topbar-right">
            <a href="https://www.facebook.com/"><FaFacebookF /></a>
            <a href="https://x.com/"><FaTwitter /></a>
            <a href="https://in.linkedin.com/?mcid=6844056167778418689&src=go-pa&trk=sem-ga_campid.14650114788_asid.145595942605_crid.651893406697_kw.www%20linkedin%20com_d.c_tid.kwd-2246447642_n.g_mt.e_geo.9197679&cid=&gclsrc=aw.ds&gad_source=1&gad_campaignid=14650114788&gbraid=0AAAAABKX7wGLJy3lXA2ThnkEiAx5YY0qh&gclid=CjwKCAiA3rPKBhBZEiwAhPNFQL5LDCu4gn7Q1-WGQEA-Dha_yrUV3KT_CtQRLNTrL1OoevzYF-TaSBoCyr4QAvD_BwE"><FaLinkedinIn /></a>
          </div>
        </div>
      </div>

      {/* ===== NAVBAR ===== */}
      <div className="nav-container">
        {/* Logo */}
        <Link to="/" onClick={handleLinkClick} className="logo-section">
          <img src="/assets/img/ca-logo.jpg" alt="Logo" className="logo" />
          <div className="logo-text">
            <h2>S D P M & Co.</h2>
            <p>Chartered Accountants</p>
          </div>
        </Link>

        {/* Hamburger */}
        <div
          className={`hamburger ${menuOpen ? "active" : ""}`}
          onClick={() => setMenuOpen(!menuOpen)}
        >
          <span></span>
          <span></span>
          <span></span>
        </div>

        {/* Navigation */}
        <nav className={`navbar ${menuOpen ? "open" : ""}`}>
          <ul className="nav-links">
            <li>
              <Link to="/" onClick={handleLinkClick}>Home</Link>
            </li>

            {/* SERVICES */}
            <li className="dropdown">
              <span className="dropdown-btn">Services ▾</span>

              <ul className="dropdown-menu">
                <li>
                  <Link to="/audit-assurance" onClick={handleLinkClick}>
                    Audit & Assurance
                  </Link>
                </li>

                {/* TAXATION SUBMENU */}
                <li className="dropdown-sub">
                  <span className="submenu-btn">Taxation & Compliance ▸</span>

                  <ul className="dropdown-submenu">
                    <li>
                      <Link to="/taxation-compliance" onClick={handleLinkClick}>
                        Taxation & Compliance
                      </Link>
                    </li>
                    <li>
                      <Link to="/direct-tax" onClick={handleLinkClick}>
                        Direct Tax (Income Tax)
                      </Link>
                    </li>
                    <li>
                      <Link to="/indirect-tax" onClick={handleLinkClick}>
                        Indirect Tax (GST)
                      </Link>
                    </li>
                  </ul>
                </li>

                {/* CAPITAL MARKET SUBMENU */}
                <li className="dropdown-sub">
                  <span className="submenu-btn">Capital Market & SEBI ▸</span>

                  <ul className="dropdown-submenu">
                    <li>
                      <Link to="/capital-market-sebi" onClick={handleLinkClick}>
                        Capital Market & SEBI Advisory
                      </Link>
                    </li>
                    <li>
                      <Link to="/depository-participant-audit" onClick={handleLinkClick}>
                        DP Audit – NSDL/CDSL
                      </Link>
                    </li>
                    <li>
                      <Link to="/system-audit-capital-market" onClick={handleLinkClick}>
                        System Audit
                      </Link>
                    </li>
                    <li>
                      <Link to="/exchange-sebi-compliances" onClick={handleLinkClick}>
                        Exchange & SEBI
                      </Link>
                    </li>
                    <li>
                      <Link to="/ipo-listing-support" onClick={handleLinkClick}>
                        IPO & Listing
                      </Link>
                    </li>
                  </ul>
                </li>

                <li>
                  <Link to="/corporate-compliance" onClick={handleLinkClick}>
                    Corporate & ROC
                  </Link>
                </li>
                <li>
                  <Link to="/business-advisory" onClick={handleLinkClick}>
                    Business Advisory
                  </Link>
                </li>
                <li>
                  <Link to="/banking-finance" onClick={handleLinkClick}>
                    Banking & Finance
                  </Link>
                </li>
                <li>
                  <Link to="/international-nri" onClick={handleLinkClick}>
                    International & NRI
                  </Link>
                </li>
                <li>
                  <Link to="/outsourcing-other" onClick={handleLinkClick}>
                    Outsourcing & Other
                  </Link>
                </li>
              </ul>
            </li>

            <li>
              <Link to="/knowledgecenter" onClick={handleLinkClick}>
                Knowledge Center
              </Link>
            </li>
            <li>
              <Link to="/about" onClick={handleLinkClick}>About Us</Link>
            </li>
            <li>
              <Link to="/career" onClick={handleLinkClick}>Career</Link>
            </li>
            <li>
              <Link to="/contactus" onClick={handleLinkClick}>Contact Us</Link>
            </li>
          </ul>
        </nav>
      </div>
    </header>
  );
}
